export const PageHeadings = {
  BLS_FEEDBACK: "BLS Feedback",
  FEEDBACK_FORMS: "Feedback Forms",
  CUSTOMER_MANAGAMENT: "Customer Management",
  NOTIFICATION_MANAGEMENT: "Notification Management",
  CONTENT_LIBRARY: "Content Library",
  CLICK_ANALYTICS: "Click Analytics",
  USER_ANALYTICS: "User Analytics",
  // MCAP itself moved to its own app; this console only controls who may
  // open it. See routeHelpers.APP_ROUTES.ADMIN_ACCESS.
  ADMIN_ACCESS: "MCAP Access",
  SCHOOL_ADMIN_REQUESTS: "School Admin Requests",
  DISTRICT_HUB: "District Hub",
  ALIGN_USERS: "Align Users",
  DATA_ERASURE: "Data Erasure",
  LICENSE_PLANS: "Plans & Pricing",
  LICENSE_PAYMENTS: "Payments",
  REDEMPTION_CODES: "Subscription Codes",
  DEMO_AVAILABILITY: "Demo Availability",
};
